module.exports = __webpack_public_path__ + "img/conexiones-download-image.d0360fac.png";